import classNames from 'classnames';
import { useCallback, useState } from 'react';
import { Button } from '..';
import GatedFormModal from './GatedFormModal';

// Text link look: inherits colour/font from the surrounding text, underlined like body-copy links
const DEFAULT_LINK_CLASS =
  'w-fit p-0 text-left text-small-paragraph font-s-light leading-desktop-small underline decoration-1 underline-offset-4 transition-opacity duration-300 hover:opacity-75';

const DEFAULT_BUTTON_CLASS = 'btn primary w-fit';

/**
 * Opens the gated form modal from a module.
 *
 * Usage inside a module component:
 *   <GatedCtaButton gatedModal={data.gatedModal} className="mt-s text-white" />
 */
const GatedCtaButton = ({
  gatedModal,
  link,
  text,
  className,
  linkClassName = DEFAULT_LINK_CLASS,
  buttonClassName = DEFAULT_BUTTON_CLASS,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const close = useCallback(() => setIsOpen(false), []);

  if (!gatedModal?.formFields) {
    if (!link) return null;
    return <Button link={text ? { ...link, text } : link} className={classNames(buttonClassName, className)} />;
  }

  const isButton = gatedModal.ctaStyle === 'button';
  const label = text || gatedModal.ctaLabel || link?.text || link?.name || 'View Full Itinerary';

  return (
    <>
      <button
        type="button"
        aria-haspopup="dialog"
        className={classNames(isButton ? buttonClassName : linkClassName, className)}
        onClick={() => setIsOpen(true)}
      >
        {label}
      </button>
      <GatedFormModal data={gatedModal} isOpen={isOpen} onClose={close} />
    </>
  );
};

export default GatedCtaButton;
